import React, { useEffect, useState, useRef } from "react";
import CommonGrid from "../CommonGrid";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { api } from "../../../redux/api";
import NtwAlert from "../../ContextMenu/NewTemplateWizard/NtwContentOptions/NtwAlert";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputBase,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import ErrorModal from "../../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import LightTooltip from "../../../commonComponents/LightTooltip";
import { newTemplateActions } from "../../../redux/slices/newTemplateSlice";
import ConfirmModal from "../../ItemProperties/Forms/FieldDataValidation/ConfirmModal";
import TradingPartnerKeyValueGrid from "./TradingPartnerKeyValueGrid";

function TradingPartnersDataGrid(props) {
  const { t } = useTranslation();
  const { setEnableApplyBtn, setData, changesApplied, setChanges, setTPName, selectedTradingPartner, refreshTrigger } = props;
  const [rowData, setRowData] = useState([]);
  const [originalRowData, setOriginalRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [tpLoading, setTpLoading] = useState(false);
  const [error, setError] = useState("");
  const [severity, setSeverity] = useState('success');
  const [searchTP, setSearchTP] = useState("");
  const [searchBtn, setSearchBtn] = useState(true);
  const [errorModal, setErrorModal] = useState(false);
  const [newTP, setNewTP] = useState({
    newValue: "",
    oldValue: "",
    action: "",
  });
  const [selectedTP, setSelectedTP] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isReverting, setIsReverting] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const unsavedChangesRef = useRef(unsavedChanges);
  const changesAppliedRef = useRef(changesApplied)
  const previousPermissionsRef = useRef(null);
  const [warningModal, setWarningModal] = useState(false);
  const [tpData, setTPData] = useState('')
  const [nextSelectedTP, setNextSelectedTP] = useState(null);
  const [pendingSelection, setPendingSeletion] = useState(null)
  const [searchIndex, setSearchIndex] = useState(0);
  const [disableFindBtn, setDisableFindBtn] = useState(true)
  const [disablecClearBtn, setDisableClearBtn] = useState(true);
  const [showCopy, setShowCopy] = useState(true);
  const dispatch = useDispatch();
  const { account } = useSelector((state) => state.queryParams);
  const userPermissions = useSelector((state) => state.userPermissions.permissions);

  const handleTPDetails = (val) =>{
    setTPData(val)
  }
  
  const getGridAPI = (api) => {
    setGridApi(api);
  };

  const CustomCellRenderer = (info) => {
    const { value, api, data, colDef } = info;
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteMessage, setDeleteMessage] = useState("");
    const [rows, setRows] = useState([]);
    const [rowIndex, setRowIndex] = useState(null);

    // Gather all row data when the component mounts or updates
    useEffect(() => {
      let tempRows = [];
      api.forEachNode((node) => {
        tempRows.push(node.data);
      });
      setRows(tempRows);
    }, [api]);

    const handleCopyAction = async (e,node) => {
      if (unsavedChangesRef.current && !changesAppliedRef.current) {
        setWarningModal(true);   
        setNextSelectedTP(node);
        return;                                    
    }
      const selectedNode = data;
      const newIndex = (selectedNode?.id || 0) + 1;
      const baseName = `Copy of ${selectedNode.tradingPartner}`;
      let newName = baseName;
      let copyNumber = 1;

      const existingNames = new Set(rows.map((row) => row.tradingPartner));
      while (existingNames.has(newName)) {
        newName = `${baseName} (${copyNumber++})`;
      }
      if(newName  && newName.length > 50){
        setErrorModal(true);
        setErrorMessage(
          <>
            The specified Name <b>{newName}</b> exceeds 50 characters
          </>
        );
        return;
      }
      const copiedRow = {
        ...selectedNode,
        id: newIndex,
        tradingPartner: newName,
      };
      const copyResponse = await copyTP(selectedNode.tradingPartner, newName);
      if (copyResponse) {
        const updatedRows = [...rows];
        updatedRows.splice(newIndex, 0, copiedRow);

        for (let i = newIndex + 1; i < updatedRows.length; i++) {
          updatedRows[i].id++;
        }
        setRowData(updatedRows);
        setOriginalRowData(updatedRows)
        setRows(updatedRows);
        setTimeout(() => {
          api.forEachNode((node) => {
            node.setSelected(node.data.id === newIndex);
            api.ensureNodeVisible(node)
          });
        }, 0);
        setTimeout(() => {
          api.startEditingCell({
            rowIndex: newIndex,
            colKey: info.column.colId,
          });
        }, 100);
      }
    };
    
    const yesHandler = async () => {
      const tpName = rows[rowIndex]?.tradingPartner;
      const deleteSuccessResponse = await deleteTP(tpName);

      if (deleteSuccessResponse) {
        const updatedRows = [...rows];
        updatedRows.splice(rowIndex, 1);

        for (let i = rowIndex; i < updatedRows.length; i++) {
          updatedRows[i].id--;
        }
        setRows(updatedRows);
        setRowData(updatedRows);
        setOriginalRowData(updatedRows)
        api.setGridOption('rowData', updatedRows)
        
        // Determine the next selection index after deletion
        let nextIndex;
        if (rowIndex === updatedRows.length - 1 && !updatedRows[updatedRows.length - 1].tradingPartner) {
          // If last item is empty and we deleted second-last item with data
          nextIndex = rowIndex - 1;
        } else {
          // For all other cases
          nextIndex = rowIndex < updatedRows.length ? rowIndex : rowIndex - 1;
        }
        if (nextIndex >= 0) {
          const selectedNode = {
            id: updatedRows[nextIndex].id,
            tradingPartner: updatedRows[nextIndex].tradingPartner,
          };

          setSelectedTP(selectedNode);
          setTPName(selectedNode)
          setTimeout(() => {
            api.forEachNode((node) => {
              node.setSelected(node.data.id === selectedNode.id);
              api.ensureNodeVisible(node)
            });
          }, 10);
          
        }
        else {
          setSelectedTP({tradingPartner:''})
        }
      }

      setOpenDeleteModal(false);
    };

    // Handle the delete action
    const handleDeleteAction = (e, rowData) => {
      const index = rowData.id;
      const tpName = rows[index]?.tradingPartner;

      setRowIndex(index);

      // Open the confirmation modal
      setDeleteMessage(
        `Are you sure you want to delete ${tpName} trading partner?`
      );
      setOpenDeleteModal(true);
    };
    const renderValue = (cellValue) => {
      if (!cellValue || /^\s*$/.test(cellValue)) {
        return <span style={{ color: "#0000008A" }}>{t("NEW_TP")}</span>;
      }
      return (
        <div
          className="truncated-text"
          title={cellValue}
          style={{ whiteSpace: "pre-wrap",display:'flex',alignItems:'center',justifyContent:'flex-start',lineHeight:'normal' }} // Preserves spaces visually
        >
          {cellValue}
        </div>
      );
    };
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "2rem",
        }}>
        {renderValue(value)}
        {(colDef.editable && data?.tradingPartner !== "" && data.hasOwnProperty('tradingPartner')) && !data.hasOwnProperty('isSearch') ? (
          <div className="flex align-center">
            {showCopy && (<LightTooltip title={"Copy Trading Partner"} arrow>
              <span
                style={{ cursor: "pointer" }}
                className="FILE_COPY"
                onClick={(e) => handleCopyAction(e, data)}></span>
            </LightTooltip>)}
            <LightTooltip title={"Delete Trading Partner"} arrow>
              <span
                style={{ cursor: "pointer" }}
                className="DELETE_MUI"
                onClick={(e) => handleDeleteAction(e, data)}></span>
            </LightTooltip>
          </div>
        ) : (
          ""
        )}
        <ConfirmModal
          openModal={openDeleteModal}
          message={deleteMessage}
          handleClose={setOpenDeleteModal}
          yesHandler={yesHandler}
          noHandler={() => setOpenDeleteModal(false)}
        />
      </div>
    );
  };
  const gridOptions = {
    columnDefs: [
      {
        addNewControl: userPermissions?.includes('TRADING_PARTNER_RIGHTS') || false,
        addControlLabel: t("LBL_ADD_NEW_TP"),
        headerName: t("ACCOUNT_TP_"),
        field: "tradingPartner",
        editable: userPermissions?.includes('TRADING_PARTNER_RIGHTS') || false,
        cellRenderer: (info) => CustomCellRenderer(info),
      },
    ],
    getRowHeight: (params) => {
      const keyValue = params.data?.tradingPartner || ""; 
      const baseHeight = 32; 
      const contentLength = keyValue.length; 

      return contentLength > 40 || keyValue.includes("\n") ? baseHeight * 1.5 : baseHeight;
    },
  };
  //Delete TP
  async function deleteTP(name) {
    if (!name) {
      return false;
    }

    try {
      const response = await dispatch(
        api.endpoints.deleteTradingPartner.initiate({
          account,
          tp_name: encodeURIComponent(name),
        }, { forceRefetch: true})
      );

      // Handle successful API response
      if (response?.data?.current_state === "SUCCESS") {
        dispatch(newTemplateActions.setShowAlert(true));
        dispatch(newTemplateActions.setAlertType('success'))
        dispatch(newTemplateActions.setAlertMessage(t('TP_DEL_SUCCESS')));
        return true;
      }

      // Handle API error response
      dispatch(newTemplateActions.setShowAlert(true));
      dispatch(newTemplateActions.setAlertType("error"));
      dispatch(
        newTemplateActions.setAlertMessage(
          response?.message || "Failed to delete Trading Partner"
        )
      );
      return false;
    } catch (error) {
      // Handle any errors during the API call
      dispatch(newTemplateActions.setShowAlert(true));
      dispatch(newTemplateActions.setAlertType("error"));
      dispatch(
        newTemplateActions.setAlertMessage(
          error.message || t('BOX_MSG_GENERAL_ERROR')
        )
      );
      return false;
    }
  }
  //Copy TP
  async function copyTP(originalTPName, copyTPName) {
    if(originalTPName && copyTPName) {
     const response = await dispatch(api.endpoints.copyTradingPartner.initiate({
        account,
        old_tp_name:encodeURIComponent(originalTPName),
        new_tp_name:encodeURIComponent(copyTPName)
      },{forceRefetch: true}))
      if(response?.data?.current_state === 'SUCCESS'){
        setSelectedTP({tradingPartner:copyTPName});
        setTPName({tradingPartner:copyTPName})
        dispatch(newTemplateActions.setShowAlert(true));
        dispatch(newTemplateActions.setAlertType('success'))
        dispatch(newTemplateActions.setAlertMessage('Trading Partner copied successfully'));
        return true;
      }
      else{
        dispatch(newTemplateActions.setShowAlert(true));
        dispatch(newTemplateActions.setAlertType('error'));
        dispatch(newTemplateActions.setAlertMessage(response?.data?.message || 'Unable to copy selected Trading Partner'));
        return false;
      }
    }
     
  }
  const postSearchClear = () => {
    setSearchBtn(true);
    setDisableFindBtn(true);
    const emptyRow = { id: originalRowData.length -1, tradingPartner: "" };
  
    // Add the empty row if not already present
    if (!originalRowData.some(row => 
      !row.hasOwnProperty('tradingPartner') || 
      (row.tradingPartner?.trim() === emptyRow.tradingPartner.trim())
  ) && userPermissions.includes('TRADING_PARTNER_RIGHTS')) {
      originalRowData.push(emptyRow); 
  }
    setRowData(originalRowData);
    setTimeout(() => {
      gridApi?.forEachNode((node) => {
        node.setSelected(node.data.id === originalRowData[0].id);
      });
    });
    setSelectedTP(originalRowData[0]);
  }
  const handleSearchChange = (e) => {
    const { value } = e.target;
    setSearchTP(value);
    if (value) {
      setDisableFindBtn(false);
      setDisableClearBtn(false);
    } else {
      postSearchClear()
      setDisableClearBtn(true);
    }
  }
  // Clear search TP
  const handleSearchClear = () => {
    if (!searchTP) return;
    setSearchTP("");
    postSearchClear();
  };

  // function to handle search TP
  const handleSearch = (tp) => {
   if(!tp) return;
   const filteredRows =  rowData.filter((row,index) => 
    typeof row.tradingPartner === "string" && row.tradingPartner.toLowerCase().includes(tp.toLowerCase())
    )
    const r = filteredRows.map((row) => {
      return {
       ...row,
       isSearch : true
       }
    })
    setRowData(r);

    setTimeout(() => {
      gridApi?.forEachNode((node) => {
        node.setSelected(node.data.id === filteredRows[0].id)
      })
    },);
    if(filteredRows.length > 1) setSearchBtn(false)
    setSelectedTP(filteredRows[0] || {tradingPartner:''});
  };

  // function to handle next
  const handleSearchNext = () => {
    const currentRows = [];
    
    // Gather all rows that match the search result
    gridApi?.forEachNode((node) => {
      currentRows.push(node.data);
    });
  
   // Calculate the next index
    const nextIndex = (searchIndex + 1) % currentRows.length;
    const nextRowData = currentRows[nextIndex];
    gridApi?.forEachNode((node) => {
      if (node.data === nextRowData) {
        gridApi.ensureNodeVisible(node, "middle");
        node.setSelected(node.data.id === nextRowData.id)
      }
    });
     setSelectedTP(nextRowData)
    setSearchIndex(nextIndex);
  };
  

  const checkDuplicateTP = (id, value, gridApi) => {
    // Don't check duplicates for empty or whitespace-only values
    if (!value || value.trim() === '') return false;
    
    let duplicateFound = false;
    gridApi?.forEachNode((node) => {
      if (node.data.id !== id && 
          node.data.tradingPartner && 
          node.data.tradingPartner.toLowerCase() === value.toLowerCase())
        duplicateFound = true;
    });
    return duplicateFound;
  };

  const applyHandler = () => {
    const createNewTP = (tp) => {
      if(!tp || tp.trim() === '') return;
      dispatch(
        api.endpoints.createNewTradingPartner.initiate({
          account,
          tp_name: encodeURIComponent(tp.trim()),
        },{forceRefetch: true})
      ).then((response) => {
        if (response?.data?.current_state === "SUCCESS") {
          dispatch(newTemplateActions.setShowAlert(true));
          dispatch(newTemplateActions.setAlertType('success'))
          dispatch(
            newTemplateActions.setAlertMessage(
              "Trading partner created successfully"
            )
          );
          setSelectedTP({id:rowData.length,tradingPartner:tp})
          setTPName({id:rowData.length,tradingPartner:tp})
          const rows = []
          gridApi?.forEachNode((node) => {
            rows.push(node.data)
          })
          setOriginalRowData(rows);
        }
        
      });
    };
    const renameExistingTP = (newValue, oldValue) => {
      if(!newValue || newValue.trim() === '' || !oldValue || oldValue.trim() === '') return;
      dispatch(
        api.endpoints.renameExistingTradingPartner.initiate({
          account,
          new_tp_name: encodeURIComponent(newValue.trim()),
          old_tp_name: encodeURIComponent(oldValue),
        },{forceRefetch: true})
      ).then((response) => {
        if (response?.data?.current_state === "SUCCESS") {
          dispatch(newTemplateActions.setShowAlert(true));
          dispatch(newTemplateActions.setAlertType('success'))
          dispatch(
            newTemplateActions.setAlertMessage(
              "Trading partner renamed successfully"
            )
          );
          setSelectedTP({tradingPartner:newValue})
          setTPName({tradingPartner:newValue})
        } else {
          dispatch(newTemplateActions.setShowAlert(true));
          dispatch(newTemplateActions.setAlertType("error"));
          dispatch(
            newTemplateActions.setAlertMessage(
              response?.data?.message || "Something went wrong"
            )
          );
        }
      });
    };
    if (newTP.newValue && newTP.action === "create")
      createNewTP(newTP.newValue);
    if (newTP.newValue && newTP.oldValue && newTP.action === "rename")
      renameExistingTP(newTP.newValue, newTP.oldValue);
  };
  // verify new TP
  const handleCellValueChanged = (gridOptions) => {
    if (errorModal) return;
    
    if (isReverting) {
      setIsReverting(false);
      return;
    }
    
    const { column, data, oldValue, api, rowIndex } = gridOptions;
    const colId = column.colId;
    const newValue = data[colId];
    const rowNode = api.getDisplayedRowAtIndex(rowIndex);
    
    // Check if newValue is empty, null, or contains only whitespace
    const isEmptyOrWhitespace = !newValue || newValue.trim() === '';
    const hadValue = oldValue && oldValue.trim() !== '';
    
    // For existing trading partners (rename), if only whitespace is entered, revert without any validation
    if (isEmptyOrWhitespace && hadValue) {
      setIsReverting(true); 
      rowNode.setDataValue(colId, oldValue || '');
      api.forEachNode((node) => {
          if (node?.data?.id === data.id) {
            node.setSelected(true);
            api.ensureNodeVisible(node);
          }
        });
      return;
    }
    
    // For new trading partners, if only whitespace is entered, show error message
    if (isEmptyOrWhitespace && !hadValue) {
      setIsReverting(true); 
      rowNode.setDataValue(colId, '');
      
      // Show error message to user
      setError(t("BOX_ENTER_VALUE_FOR_NEW_TRADE_PARTNER") || "Please enter a valid trading partner name");
      setSeverity('warning');
      
      // Keep the current row selected but set selectedTP to empty to show empty grid on right
      api.forEachNode((node) => {
        if (node?.data?.id === data.id) {
          node.setSelected(true);
          api.ensureNodeVisible(node);
        }
      });
      setSelectedTP({tradingPartner: ''});
      setTPName({tradingPartner: ''});
      
      return;
    }
    if (newValue === oldValue) return;

    if (colId === "tradingPartner") {
      const id = data.id;
      // Check if the cell value exceeds the character limit
      if (newValue && newValue.length > 50) {
        setErrorModal(true);
        setErrorMessage(t("BOX_NAME_TOO_LONG"));
        
        rowNode.setDataValue(colId, oldValue || '');
        setSelectedTP({ tradingPartner: oldValue });

        setTimeout(() => {
          api.forEachNode((node) => {
            if (node?.data?.id === id) {
              node.setSelected(true);
              api.ensureNodeVisible(node);
            }
          });
        }, 50);

        return;
      }
      const isDuplicateTP = checkDuplicateTP(id, newValue.trim(), api);

      if (isDuplicateTP) {
        setErrorModal(true);
        setErrorMessage(t("BOX_ENTER_DIFF_NM_FOR_NEW_TRADE_PARTNER"));
        rowNode.setDataValue(colId, oldValue || "");
        setSelectedTP({tradingPartner:oldValue})
      } else {
        const action = oldValue ? "rename" : "create";
        setNewTP({ newValue, oldValue, action });
      }
      setTimeout(() => {
        api.forEachNode((node) => {
          if (node?.data?.id === id) {
            node.setSelected(true);
            api.ensureNodeVisible(node);
          }
        });
      }, 100);
    }
  };
  
  const handleRowClicked = (event) => {
    const selectedNodes = event.api.getSelectedNodes();
    // setUnsavedChanges(false);
    // Check if there are no selected nodes or the clicked node isn't already selected
    if (selectedNodes.length === 0 || !selectedNodes.find((node) => node.id === event.node.id)) {
  
      // Check for unsaved changes and if changes are not yet applied
      if (unsavedChanges && !changesApplied) {
          setWarningModal(true);   
          setNextSelectedTP(event.node.data);
          return;                                    
      }
  
      // If user confirms or no unsaved changes, switch the selection
      setEnableApplyBtn(false)
      setChanges(false)
      event.node.setSelected(true);
      setSelectedTP(event.node.data); 
      setTPName(event.node.data)
    }
  };
  
  const handleWarningModalClose = () => {
    setWarningModal(false);
  };
  const handleApplyChanges = () => {
    setUnsavedChanges(false);
    setEnableApplyBtn(false)
   
    if (pendingSelection) {
      setTimeout(() => {
        gridApi?.forEachNode((node) => {
          node.setSelected(node.data.id === pendingSelection.id);
        });
      }, 0);
      
      setSelectedTP(pendingSelection);
      setTPName(pendingSelection)
      setNextSelectedTP(null);
      setPendingSeletion(null)
    }
  };
  const applyChangesHandler = async (data) => {
    if(data){
      const response = await dispatch(api.endpoints.updateTradingPartnerDetails.initiate({
        account,
        data
      },{forceRefetch: true}))
      if(response?.data?.current_state === 'SUCCESS'){
         setPendingSeletion(nextSelectedTP)
         setWarningModal(false)
         setError(t('UPDATE_TP_MSG'))
         setSeverity('success')
         
      } else if(response?.data?.current_state === 'ERROR') {
          setPendingSeletion(null)
          setWarningModal(false)
          setError(response?.data?.data[0] || response?.data?.message || t('BOX_MSG_GENERAL_ERROR'))
          setSeverity('error')
          
       } else {
        setError(response?.data?.message || t('BOX_MSG_GENERAL_ERROR'))
        setSeverity('error')
      }
    }
  }
  const onGridReady = (params) => {
    // Accessing grid's API once it's ready
    params.api.sizeColumnsToFit();
    setGridApi(params.api);
  
    let firstRowNode;
  
    if (selectedTradingPartner) {
      // Find the row node matching selectedTradingPartner
      params.api.forEachNode((node) => {
        if (node.data && node.data.tradingPartner === selectedTradingPartner.tradingPartner) {
          firstRowNode = node;
        }
      });
    } else {
      // Get the first displayed row node
      firstRowNode = params.api.getDisplayedRowAtIndex(0);
    }
  
    // Select the row if a valid row node is found
    if (firstRowNode) {
      firstRowNode.setSelected(true);
      params.api.ensureNodeVisible(firstRowNode)
    }
  };
  const handleUnsavedChanges = (value) => {
    setUnsavedChanges(value)
  }
  const getBridgegateConfig = async (account) => {
    if(account){
      const response = await dispatch(api.endpoints.getBridgegateConfig.initiate({
        account
      },{forceRefetch: true}));
      if(response?.data?.current_state === 'SUCCESS'){
          const tpInfo = response?.data?.data?.TRADING_PARTNER_INFO;
          if(tpInfo.hasOwnProperty('UNIQUE_COMPOSITE') && tpInfo['UNIQUE_COMPOSITE'] === "TRUE"){
            setShowCopy(false)
          }
      }
    }
  }
  // function to get all trading partners
  const getTradingPartners = async (account) => {
    setTpLoading(true);
    try {
      const response = await dispatch(
        api.endpoints.getTradingPatners.initiate(
          {
            account: account,
          },
          { forceRefetch: true }
        )
      );

      if (response?.error) {
        setError(t("ERR_TP"));
        setSeverity('error')
      } else if (response?.data?.current_state === "SUCCESS") {
        getBridgegateConfig(account);
        const data = response?.data?.data?.trading_partners;

        if (!data || data.length === 0) {
          if(userPermissions.includes("TRADING_PARTNER_RIGHTS")) setRowData([{ id: 0, tradingPartner: "" }]);
          else setRowData([])
        } else {
          const rData = data
            .map((tp, key) => {
              return { id: key, tradingPartner: tp };
            })
            .sort((a, b) => {
              return a?.tradingPartner.localeCompare(b?.tradingPartner);
            }).map((item, index) => {
              return { ...item, id: index }; // Re-assign IDs in sorted order
            });
          if (userPermissions.includes("TRADING_PARTNER_RIGHTS")) {
            rData.push({
              id: rData.length,
              tradingPartner: "",
            });
          }
          setRowData(rData);
          setOriginalRowData(rData)
          setSelectedTP(selectedTradingPartner || rData[0]);  
          setTPName(rData[0])        
          
        }
      } else {
        setRowData([{ id: 0, tradingPartner: "" }]);
      }
    } catch (error) {
      setError(t('BOX_MSG_GENERAL_ERROR'));
      setSeverity('error')
    } finally {
      setTpLoading(false);
    }
  };

  useEffect(() => {
    if (userPermissions !== undefined && account) {
      const prevHasRights = previousPermissionsRef.current?.includes('TRADING_PARTNER_RIGHTS') || false;
      const currentHasRights = userPermissions.includes('TRADING_PARTNER_RIGHTS');
      const rightsChanged = prevHasRights !== currentHasRights;
      
      if (previousPermissionsRef.current === null || rightsChanged) {
        getTradingPartners(account);
        previousPermissionsRef.current = userPermissions;
      }
    }
  }, [userPermissions, account]);

  useEffect(() => {
    if (account) {
      getTradingPartners(account);
    }
  }, [refreshTrigger]);

  useEffect(() => {
    if (newTP.action) applyHandler();
  }, [newTP]);
  
  useEffect(() => {
   if(selectedTradingPartner) setSelectedTP(selectedTradingPartner)
  },[selectedTradingPartner])

  useEffect(() => {
    handleApplyChanges()
  },[pendingSelection])

  useEffect(() => {
    unsavedChangesRef.current = unsavedChanges;
  }, [unsavedChanges]);
  
  useEffect(() => {
    changesAppliedRef.current = changesApplied;
    if (changesApplied) {
      setChanges(false);
    }
  }, [changesApplied]);

  return (
    <>
      <div>
        {/* Loading until api gets response for trading partners */}
        {tpLoading ? (
          <div
            className="pdc-container"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}>
            {" "}
            <CircularProgress />{" "}
          </div>
        ) : (
          <div className="pdc-container" style={{ boxSizing: "border-box",height:'calc(100vh - 230px)'}}>
            {/* Left container  */}
            <div className="pdc-left-container" style={{ marginLeft: "5px" }}>
              <div className="pdc-left-inner width-100 height-100">
                <div className="flex">
                  {/* search TP */}
                  <div className="search" >
                    <InputBase
                      variant="outlined"
                      className="search-input width-100"
                      placeholder={t("FIND_TP")}
                      value={searchTP || ""}
                      onChange={(e) => {handleSearchChange(e)}}
                      endAdornment={
                        <IconButton onClick={handleSearchClear} disabled={disablecClearBtn} size="small">
                          <ClearIcon
                            style={{ fontSize: "15px", padding: "0" }}
                          />
                        </IconButton>
                      }
                    />
                    {searchBtn && (
                      <Button size="small" disabled={disableFindBtn} onClick={() => handleSearch(searchTP)}>
                        {t("DIAG_SEARCH_FIND")}
                      </Button>
                    )}
                    {!searchBtn && (
                      <Button size="small" onClick={handleSearchNext}>
                        {t("NEXT")}
                      </Button>
                    )}
                  </div>
                </div>
                {/* all TPs */}
                <div style={{ height: "100%" }}>
                  <CommonGrid
                    rowData={rowData}
                    gridOptions={gridOptions}
                    getGridAPI={getGridAPI}
                    containerStyle={{
                      height: "100%",
                    }}
                    gridProps={{
                      onCellValueChanged: handleCellValueChanged,
                      onRowClicked: handleRowClicked,
                      onGridReady: onGridReady,
                      ensureDomOrder: true,
                    }}
                    rowSelection="single"
                  />
                </div>
              </div>
            </div>
            {/* Right Container */}
            <div className="pdc-right-container" style={{padding:'3px'}}>
              <TradingPartnerKeyValueGrid
                selectedTP={selectedTP}
                setEnableApply={setEnableApplyBtn}
                setData={setData}
                setUnsavedChanges={handleUnsavedChanges}
                setTPDetails={handleTPDetails}
              />
            </div>
          </div>
        )}
      </div>
      {error && (
        <NtwAlert
          open={Boolean(error)}
          message={error}
          type={severity}
          hideDuration={10000}
          onClose={() => setError("")}
        />
      )}
      {errorModal && (
        <ErrorModal
          errorModal={errorModal}
          errorMessage={errorMessage}
          OkHandler={() => {
            setErrorModal(false);
          }}
        />
      )}
      {warningModal && (
        <ConfirmApplyModal
          applyModal={warningModal}
          handleApplyCancel={handleWarningModalClose}
          tp={selectedTP.tradingPartner}
          applyHandler={() => applyChangesHandler(tpData)}
        />
      )}
    </>
  );
}

export default TradingPartnersDataGrid;

export const ConfirmApplyModal = ({ applyModal, tp, applyHandler, handleApplyCancel }) => {
  const { t } = useTranslation();
  return <>
    <Dialog
      open={applyModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle className='dialog-header'>
        <div className="title">
          {t("BOX_CONFIRM")}
        </div>
      </DialogTitle>

      <DialogContent className='modal-content' dividers>
        {t('THERE_ARE_UNSAVED_CHANGES_MADE_TO')?.split('{0}').join(' ')} - <span className="bold">{tp}</span>
      </DialogContent>

      <DialogActions>
        <Button
          size='small'
          variant="outlined"
          color="primary"
          onClick={applyHandler}>
          {t("APPLY")}
        </Button>
        <Button
          size='small'
          variant="outlined"
          color="primary"
          onClick={handleApplyCancel}>
          {t("BTN_CANCEL")}
        </Button>
      </DialogActions>
    </Dialog>
  </>
}